<template>
  <v-card
    loader-height="8"
    :loading="admin.productsLoading"
    :disabled="admin.productsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5"> Delete File? </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteProductDetails">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue" class="text-h4 text-uppercase" dark>
      Product Details
      <v-spacer></v-spacer>
      <v-icon>{{ app.systemIcon }}</v-icon>
    </v-toolbar>
    <v-tabs vertical right color="blue">
      <v-tab>Attribute Values</v-tab>
      <v-tab>Accessories</v-tab>
      <v-tab>Images</v-tab>
      <v-tab>Requirements</v-tab>
      <v-tab>Settings</v-tab>
      <v-tab>Details File</v-tab>
      <v-tab-item>
        <attribute-value-list class="pb-6"></attribute-value-list>
        <attribute-value-edit
          :minCardHeight="600"
          v-show="admin.selectedProductAttributeValue != null"
        ></attribute-value-edit>
      </v-tab-item>
      <v-tab-item>
        <accessory-list></accessory-list>
        <accessory-edit
          v-show="admin.selectedProductAccessory != null"
        ></accessory-edit>
      </v-tab-item>
      <v-tab-item><image-list></image-list></v-tab-item>
      <v-tab-item>
        <requirement-list></requirement-list>
        <requirement-edit
          v-show="admin.selectedProductRequirement != null"
        ></requirement-edit>
      </v-tab-item>
      <v-tab-item>
        <setting-list></setting-list>
        <setting-edit
          v-show="admin.selectedProductSetting != null"
        ></setting-edit>
      </v-tab-item>
      <v-tab-item>
        <v-chip
          v-if="admin.selectedProduct.detailsSource"
          class="pl-16 mx-4 my-4"
          color="primary"
          dark
          large
          @click="viewFile"
          >{{ getFileName(admin.selectedProduct.detailsSource) }}
          <v-icon
            class="ml-16 mr-2"
            @click.stop.prevent="showConfirmationDialog = true"
            right
          >
            mdi-delete
          </v-icon></v-chip
        >
        <drop-file
          saveAction="admin/saveProductDetails"
          :allowMultiple="false"
          accept=".*"
        />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import AccessoryEdit from './details/AccessoryEdit.vue';
  import AccessoryList from './details/AccessoryList.vue';
  import AttributeValueEdit from './details/ProductAttributeValueEdit.vue';
  import AttributeValueList from './details/ProductAttributeValueList.vue';
  import ImageList from './details/ImageList.vue';
  import RequirementList from './details/RequirementList.vue';
  import RequirementEdit from './details/RequirementEdit.vue';
  import SettingList from './details/SettingList.vue';
  import SettingEdit from './details/SettingEdit.vue';
  import DropFile from '@/components/file/DropFile.vue';

  export default {
    components: {
      AttributeValueList,
      AccessoryList,
      ImageList,
      RequirementList,
      RequirementEdit,
      SettingList,
      SettingEdit,
      AttributeValueEdit,
      AccessoryEdit,
      DropFile
    },
    props: {
      minCardHeight: Number
    },
    data() {
      return {
        showConfirmationDialog: false
      };
    },
    computed: {
      ...mapState(['app', 'admin'])
    },
    methods: {
      /**
       * Deletes the product details
       */
      deleteProductDetails() {
        this.$store
          .dispatch('admin/deleteProductDetails', this.admin.selectedProduct.id)
          .then(() => {
            this.showConfirmationDialog = false;
            this.$store.dispatch('admin/getProductList');
          });
      },
      /**
       * Opens the file in a new tab
       
       */
      viewFile() {
        // open file in a new tab
        window.open(this.admin.selectedProduct.detailsSource, '_blank');
      },
      /**
       * Gets the file name from the file path
       * @param {String} file
       */
      getFileName(file) {
        return file.split('/').pop();
      }
    }
  };
</script>
